import { isUsEinCountry, validateEIN } from 'careit';

const CANADA_COUNTRIES = new Set(['CA', 'Canada']);

export function normalizeEinValue(value) {
  return typeof value === 'string' ? value.trim() : value;
}

export function isUnitedStatesCountry(country) {
  return isUsEinCountry(country);
}

export function isCanadaCountry(country) {
  return CANADA_COUNTRIES.has(country);
}

export function isEinRequiredCountry(country) {
  return isUnitedStatesCountry(country) || isCanadaCountry(country);
}

export function getEinLabel(country) {
  if (isUnitedStatesCountry(country)) {
    return 'EIN';
  }

  if (isCanadaCountry(country)) {
    return 'Business Number';
  }

  return 'EIN / Business Number';
}

// Executive (city) users may create placeholder recipients without knowing
// the EIN; the backend enforces the same rule from the session.
export function isRecipientEinRequired({ isNonProfit, isExecutive, country }) {
  return Boolean(isNonProfit) && !isExecutive && isEinRequiredCountry(country);
}

export function getOptionalEinError({
  value,
  country,
  shouldValidate = true,
  required = false,
  label = getEinLabel(country),
}) {
  if (!shouldValidate || !isEinRequiredCountry(country)) {
    return null;
  }

  const normalizedValue = normalizeEinValue(value);

  if (!normalizedValue) {
    return required ? `${label} is required` : null;
  }

  return validateEIN(normalizedValue, country).valid
    ? null
    : `Enter a valid ${label}`;
}

export function shouldShowOrgEinTask({
  ein,
  country,
  isAdmin,
  isNonProfit,
  isFoodMover,
}) {
  if (
    !isAdmin ||
    !(isNonProfit || isFoodMover) ||
    !isEinRequiredCountry(country)
  ) {
    return false;
  }

  return !validateEIN(normalizeEinValue(ein) || '', country).valid;
}
